import React from 'react';
import { useTheme } from '@mui/material/styles';
import Backdrop from '@mui/material/Backdrop';
import ShareIcon from '@mui/icons-material/Share';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import MailIcon from '@mui/icons-material/Mail';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import CloseIcon from '../icons/close-icon';
import { COLORS, GLOBAL } from '../../constants';
import { logTrackingEvent } from '../../utils/tracking';
import logger from '../../utils/logger';
import styled from '@emotion/styled';

import { TEXT, TITLE } from './constants';

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'url' implicitly has an 'any' type.
const actions = (url) => [
  {
    icon: <TwitterIcon titleAccess="Share to Twitter" />,
    id: 'share-to-twitter-link',
    name: 'Share to Twitter',
    url: `https://twitter.com/intent/tweet?text=${url}`,
  },
  {
    icon: <FacebookIcon titleAccess="Share to Facebook" />,
    id: 'share-to-facebook-link',
    name: 'Share to Facebook',
    url: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
  },
  {
    icon: <MailIcon titleAccess="Share via Email" />,
    id: 'share-via-email-link',
    name: 'Share via Email',
    url: `mailto:?subject=${TITLE}&body=${TEXT} ${url}`,
  },
];

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'open' implicitly has an 'any' type.
const FabIcon = ({ open }) => {
  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up('md'));
  return (
    <>
      {open ? <CloseIcon white /> : <ShareIcon />}
      {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ children: string; component: string; }' is not assignable to type 'IntrinsicAttributes & TypographyOwnProps & CommonProps & Omit<Omit<DetailedHTMLProps<HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>, "ref"> & { ...; }, "alignContent" | ... 112 more ... | "variantMapping"> & { ...; }'. */}
      {mdUp && <StyledTypography component="span">{open ? 'Close' : 'Share'}</StyledTypography>}
    </>
  );
};

const StyledTypography = styled(Typography)`
  font-family: ${GLOBAL.BRAND_FONT_FAMILY};
  margin-left: 16px;
  text-transform: uppercase;
`;

const StyledBackdrop = styled(Backdrop)`
  background-color: rgba(0, 0, 0, 0.35);
`;

const StyledWrapper = styled(Box)`
  position: fixed;
  bottom: 5vh;
  right: 5vw;
`;

const StyledSpeedDial = styled(SpeedDial)`
  & .MuiFab-primary {
    background-color: ${COLORS.GREY_TEN};
  }
  & .MuiSvgIcon-root {
    font-size: 20px;
  }
`;

const StyledSpeedDialAction = styled(SpeedDialAction)`
  & .MuiSvgIcon-root {
    font-size: 20px;
  }
`;

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'fullUrl' implicitly has an 'any' type.
const ShareFab = ({ fullUrl }) => {
  const shareUrl = fullUrl || window.location;
  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up('md'));
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    logTrackingEvent({
      event: 'share',
    });
    if (navigator.share) {
      const url = window.location.href;
      navigator
        .share({
          title: TITLE,
          text: TEXT,
          url,
        })
        .then(() => {
          logger.info('Successfully shared with Web API', { url });
        })
        .catch((err) => {
          logger.error('Error sharing with Web API', err, { url });
        });
    } else {
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <StyledWrapper>
      <StyledBackdrop open={open} />
      <StyledSpeedDial
        ariaLabel="share"
        icon={<FabIcon open={open} />}
        onOpen={handleOpen}
        onClose={handleClose}
        open={open}
        FabProps={{
          size: mdUp ? 'large' : 'small',
          // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '"round" | "extended"' is not assignable to type 'OverridableStringUnion<"extended" | "circular", FabPropsVariantOverrides> | undefined'.
          variant: mdUp ? 'extended' : 'round',
        }}
      >
        {actions(shareUrl).map((action) => (
          <StyledSpeedDialAction
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
            onClick={handleClose}
            FabProps={{
              'aria-describedby': action.id,
              href: action.url,
              id: action.id,
              // @ts-expect-error [🤖 PLEASE FIX 🤖]: Object literal may only specify known properties, and 'target' does not exist in type 'Partial<FabProps>'.
              target: '_blank',
              rel: 'noopener',
            }}
          />
        ))}
      </StyledSpeedDial>
    </StyledWrapper>
  );
};

export default ShareFab;
